import React from 'react';
interface IconProps {
  className?: string;
}
const baseProps = {
  width: 28,
  height: 28,
  viewBox: '0 0 28 28',
  fill: 'none',
  stroke: '#D8C5A0',
  strokeWidth: 1.5,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true
};
// KEBABS — rolled wrap, abstract
export function KebabIcon({
  className
}: IconProps) {
  return <svg {...baseProps} className={className} data-id="element-115" data-mp="2lrghp286et7a">
      <path d="M9 4.5 L19 4.5 L21.5 23.5 L6.5 23.5 Z" data-id="element-116" data-mp="26zof7qthd9mz" />
      <path d="M9 9 L19 9" data-id="element-117" data-mp="2brfz5ii4sh45" />
      <path d="M8.5 14 L19.5 14" data-id="element-118" data-mp="2brpnl1nj2g7q" />
      <path d="M8 19 L20 19" data-id="element-119" data-mp="2bsr0zcs0nesm" />
    </svg>;
}
// PAPAS HORNEADAS — whole baked potato, simple oval with texture lines
export function PotatoIcon({
  className
}: IconProps) {
  return <svg {...baseProps} className={className} data-id="element-120" data-mp="22zxkxd4qwbdp">
      {/* Simple oval potato body, gently rotated */}
      <ellipse cx="14" cy="14" rx="9.5" ry="6.5" transform="rotate(-20 14 14)" data-id="element-121" data-mp="1o36jyzffarlz" />
      {/* Texture lines following the form */}
      <path d="M10 12.5 C12 11.6 16 11 19 12" data-id="element-122" data-mp="6naym2sbnmb1" />
      <path d="M9.5 15.5 C12 14.6 16 14 18.5 15" data-id="element-123" data-mp="6q6wjr466azh" />
    </svg>;
}
// EXTRAS — fries in a cone
export function FriesIcon({
  className
}: IconProps) {
  return <svg {...baseProps} className={className} data-id="element-124" data-mp="fnqxt02187a3">
      <path d="M9 11 L19 11 L16.5 24 L11.5 24 Z" data-id="element-125" data-mp="fmfvl4o8j7l3" />
      <path d="M10.5 11 L9.5 4" data-id="element-126" data-mp="bo8do6i1c08b" />
      <path d="M13 11 L12.5 3.5" data-id="element-127" data-mp="bnypmogjw359" />
      <path d="M15.5 11 L16 3.5" data-id="element-128" data-mp="3k2qq0kf0e1xq" />
      <path d="M18 11 L19 4.5" data-id="element-129" data-mp="3k3s3evjhz0im" />
    </svg>;
}
// BEBIDAS — simple glass, no ice, no straw
export function GlassIcon({
  className
}: IconProps) {
  return <svg {...baseProps} className={className} data-id="element-130" data-mp="3sval5aw3dodt">
      <path d="M9 5 L19 5 L17.5 23 L10.5 23 Z" data-id="element-131" data-mp="3sw3sacyyqfwh" />
    </svg>;
}